import { render, staticRenderFns } from "./DrawRecord.vue?vue&type=template&id=271ee307&"
import script from "./DrawRecord.vue?vue&type=script&lang=js&"
export * from "./DrawRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports